import { getDominantSpeakerParticipant, isLocalParticipantModerator } from '../base/participants/functions';
import { ADD_LIVE_TRANSLATION_LINE, CLEAR_LIVE_TRANSLATION, UPDATE_LAST_LIVE_TRANSLATION_LINE } from './actionTypes';
export const addLiveTranslationLine = (text, lang, participantId) => ({
    type: ADD_LIVE_TRANSLATION_LINE,
    text,
    lang,
    participantId
});
export const clearLiveTranslation = () => ({ type: CLEAR_LIVE_TRANSLATION });
// Thin wrapper around Google Translate API (v2) via HTTP. User must provide key in config.translation?.googleApiKey
export const translateToHindiIfModerator = (original) => async (dispatch, getState) => {
    try {
        const state = getState();
        const { translation } = state['features/base/config'];
        const apiKey = translation?.googleApiKey;
        if (!apiKey) {
            return; // no key, skip
        }
        // Only translate if dominant speaker is local moderator
        const dom = getDominantSpeakerParticipant(state);
        const isMod = isLocalParticipantModerator(state);
        if (!isMod || !dom?.local) {
            return;
        }
        const url = `https://translation.googleapis.com/language/translate/v2?key=${encodeURIComponent(apiKey)}`;
        const body = {
            q: original,
            target: 'hi'
        };
        const res = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        });
        if (!res.ok) {
            return;
        }
        const json = await res.json();
        const translated = json?.data?.translations?.[0]?.translatedText;
        if (translated) {
            dispatch(addLiveTranslationLine(translated, 'hi', dom.id));
        }
    }
    catch {
        // ignore network errors
    }
};
export const updateLastLiveTranslationLine = (text) => ({
    type: UPDATE_LAST_LIVE_TRANSLATION_LINE,
    text
});
